import { PartyPopper, Store } from "lucide-react";

const OPTIONS = [
  { k: "curtir", label: "Quero curtir os rolês", sub: "Achar e criar rolês", icon: PartyPopper },
  { k: "adega", label: "Sou adega", sub: "Colocar minha loja no mapa", icon: Store },
];

export default function AccountTypeChooser({ value, onChange }) {
  return (
    <div className="grid grid-cols-2 gap-2 mb-6" data-testid="account-type-chooser">
      {OPTIONS.map(({ k, label, sub, icon: Icon }) => (
        <button key={k} type="button" onClick={() => onChange(k)} data-testid={`account-type-${k}`}
          className={`press text-left rounded-2xl border p-3 transition-colors ${value === k ? "border-primary bg-primary/10" : "border-white/10 bg-card"}`}>
          <Icon className={`w-5 h-5 mb-2 ${value === k ? "text-primary" : "text-muted-foreground"}`} />
          <div className="text-sm font-bold">{label}</div>
          <div className="text-[11px] text-muted-foreground leading-tight">{sub}</div>
        </button>
      ))}
    </div>
  );
}
